{
  "characterModels": [
    {
      "id": "dreamer",
      "model": {
        "expectedClips": [
          "Idle",
          "Walking_A",
          "Running_A",
          "Sneaking",
          "Walking_Backwards",
          "Running_Strafe_Left",
          "Running_Strafe_Right",
          "Death_A",
          "Hit_A",
          "Interact"
        ],
        "stem": "WachenKaempfer"
      }
    },
    {
      "id": "libus",
      "model": {
        "expectedClips": [
          "Idle",
          "Walking_A",
          "Running_A"
        ],
        "stem": "Libus"
      }
    },
    {
      "id": "merchant",
      "model": {
        "expectedClips": [
          "Idle",
          "Walking_A",
          "Running_A"
        ],
        "stem": "Kraemer"
      }
    },
    {
      "id": "fighter-master",
      "model": {
        "expectedClips": [
          "Idle",
          "Walking_A",
          "Running_A"
        ],
        "stem": "KaempferMeister"
      }
    },
    {
      "id": "ghost",
      "model": {
        "expectedClips": [
          "Flying_Idle",
          "Death",
          "HitReact",
          "Punch"
        ],
        "stem": "Gespenst"
      }
    }
  ],
  "objectModels": [
    {
      "footprint": {
        "depth": 0.42,
        "width": 1.28
      },
      "id": "bookshelf-ornate",
      "model": {
        "expectedClips": [],
        "stem": "BookshelfOrnate"
      }
    },
    {
      "footprint": {
        "depth": 0.35,
        "width": 1.28
      },
      "id": "bookshelf",
      "model": {
        "expectedClips": [],
        "stem": "Bookshelf"
      }
    },
    {
      "footprint": {
        "depth": 0.36,
        "width": 0.36
      },
      "id": "potted-plant",
      "model": {
        "expectedClips": [],
        "stem": "PottedPlant"
      }
    },
    {
      "footprint": {
        "depth": 0.36,
        "width": 0.36
      },
      "id": "study-table",
      "model": {
        "expectedClips": [],
        "stem": "StudyTable"
      }
    },
    {
      "footprint": {
        "depth": 0.49,
        "width": 0.64
      },
      "id": "bust",
      "model": {
        "expectedClips": [],
        "stem": "Bust"
      }
    },
    {
      "footprint": {
        "depth": 0.35,
        "width": 2.56
      },
      "id": "grand-bookcase",
      "model": {
        "expectedClips": [],
        "stem": "GrandBookcase"
      }
    },
    {
      "footprint": {
        "depth": 0.3,
        "width": 0.36
      },
      "id": "couch",
      "model": {
        "expectedClips": [],
        "stem": "Couch"
      }
    },
    {
      "footprint": {
        "depth": 0.43,
        "width": 0.43
      },
      "id": "floor-lamp",
      "light": {
        "kind": "lamp",
        "x": 0,
        "y": 0.93,
        "z": 0
      },
      "model": {
        "expectedClips": [],
        "stem": "FloorLamp"
      }
    },
    {
      "footprint": {
        "depth": 0.65,
        "width": 0.65
      },
      "id": "side-table",
      "model": {
        "expectedClips": [],
        "stem": "SideTable"
      }
    },
    {
      "footprint": {
        "depth": 0.37,
        "width": 0.32
      },
      "id": "chair",
      "model": {
        "expectedClips": [],
        "stem": "Chair"
      }
    },
    {
      "footprint": {
        "depth": 2.84,
        "width": 3.2
      },
      "id": "tent",
      "model": {
        "expectedClips": [],
        "stem": "Tent"
      }
    },
    {
      "colliders": [
        {
          "depth": 0.23,
          "width": 0.23,
          "x": -0.133,
          "z": -0.024
        }
      ],
      "footprint": {
        "depth": 0.981,
        "width": 1.112
      },
      "id": "pine-tree",
      "model": {
        "expectedClips": [],
        "stem": "PineTree"
      }
    },
    {
      "footprint": {
        "depth": 1.67,
        "width": 1.92
      },
      "id": "well",
      "model": {
        "expectedClips": [],
        "stem": "Brunnen"
      }
    },
    {
      "colliders": [
        {
          "depth": 7.0,
          "width": 5.32,
          "x": -3.9,
          "z": -3.5
        },
        {
          "depth": 3.23,
          "width": 1.08,
          "x": 1.42,
          "z": -3.5
        },
        {
          "depth": 0.85,
          "width": 0.85,
          "x": 2.55,
          "z": -0.9
        }
      ],
      "doors": [
        {
          "facing": 90,
          "id": "main",
          "width": 1.52,
          "x": 1.42,
          "z": 0.9
        }
      ],
      "footprint": {
        "depth": 7.05,
        "width": 7.68
      },
      "id": "building-townhall",
      "model": {
        "expectedClips": [],
        "stem": "BuildingTownhall"
      },
      "walkSurfaces": [
        {
          "depth": 3.62,
          "height": 1.03,
          "width": 1.0,
          "x": 1.42,
          "z": -0.27
        },
        {
          "depth": 1.72,
          "height": 1.03,
          "width": 0.4,
          "x": 2.42,
          "z": 0.04
        },
        {
          "depth": 1.72,
          "height": 0.77,
          "width": 0.35,
          "x": 2.82,
          "z": 0.04
        },
        {
          "depth": 1.72,
          "height": 0.52,
          "width": 0.33,
          "x": 3.17,
          "z": 0.04
        },
        {
          "depth": 1.72,
          "height": 0.26,
          "width": 0.35,
          "x": 3.5,
          "z": 0.04
        }
      ]
    },
    {
      "colliders": [
        {
          "depth": 5.16,
          "width": 3.96,
          "x": -2.27,
          "z": -2.81
        },
        {
          "depth": 2.69,
          "width": 0.23,
          "x": 1.69,
          "z": -2.73
        },
        {
          "depth": 1.01,
          "width": 0.17,
          "x": 1.69,
          "z": 1.3
        },
        {
          "depth": 2.09,
          "width": 1.15,
          "x": 1.92,
          "z": -2.54
        },
        {
          "depth": 1.88,
          "width": 0.93,
          "x": -3.2,
          "z": -0.27
        }
      ],
      "doors": [
        {
          "facing": 90,
          "id": "main",
          "width": 1.14,
          "x": 1.69,
          "z": 0.63
        }
      ],
      "footprint": {
        "depth": 5.63,
        "width": 6.4
      },
      "id": "building-tavern",
      "model": {
        "expectedClips": [],
        "stem": "BuildingTavern"
      },
      "walkSurfaces": [
        {
          "depth": 1.34,
          "height": 1.01,
          "width": 0.5,
          "x": 1.69,
          "z": -0.04
        },
        {
          "depth": 1.34,
          "height": 0.76,
          "width": 0.34,
          "x": 2.19,
          "z": -0.04
        },
        {
          "depth": 1.34,
          "height": 0.5,
          "width": 0.33,
          "x": 2.53,
          "z": -0.04
        },
        {
          "depth": 1.34,
          "height": 0.25,
          "width": 0.34,
          "x": 2.86,
          "z": -0.04
        }
      ]
    },
    {
      "colliders": [
        {
          "depth": 5.87,
          "width": 5.79,
          "x": -3.15,
          "z": -2.93
        },
        {
          "depth": 0.36,
          "width": 0.2,
          "x": 2.64,
          "z": -0.94
        },
        {
          "depth": 0.33,
          "width": 0.2,
          "x": 2.64,
          "z": 0.58
        },
        {
          "depth": 0.88,
          "width": 0.56,
          "x": 2.64,
          "z": 0.91
        }
      ],
      "doors": [
        {
          "facing": 90,
          "id": "main",
          "width": 1.16,
          "x": 2.64,
          "z": 0
        }
      ],
      "footprint": {
        "depth": 5.88,
        "width": 6.4
      },
      "id": "building-barracks",
      "model": {
        "expectedClips": [],
        "stem": "BuildingBarracks"
      },
      "walkSurfaces": [
        {
          "depth": 1.68,
          "height": 0.2,
          "width": 0.31,
          "x": 2.64,
          "z": -0.84
        }
      ]
    },
    {
      "footprint": {
        "depth": 3.33,
        "width": 3.84
      },
      "id": "building-tower",
      "model": {
        "expectedClips": [],
        "stem": "BuildingTower"
      }
    },
    {
      "footprint": {
        "depth": 4.28,
        "width": 5.12
      },
      "id": "building-keep",
      "model": {
        "expectedClips": [],
        "stem": "BuildingKeep"
      }
    },
    {
      "colliders": [
        {
          "depth": 4.56,
          "width": 3.6,
          "x": -2.56,
          "z": -2.28
        },
        {
          "depth": 1.9,
          "width": 1.21,
          "x": 1.04,
          "z": -0.95
        }
      ],
      "doors": [
        {
          "facing": 90,
          "id": "main",
          "width": 0.9,
          "x": 2.25,
          "z": 0
        }
      ],
      "footprint": {
        "depth": 4.56,
        "width": 5.12
      },
      "id": "building-chapel",
      "model": {
        "expectedClips": [],
        "stem": "BuildingChapel"
      }
    },
    {
      "colliders": [
        {
          "depth": 4.08,
          "width": 3.14,
          "x": -2.05,
          "z": -2.04
        },
        {
          "depth": 0.65,
          "width": 0.17,
          "x": 1.09,
          "z": -1.96
        },
        {
          "depth": 1.96,
          "width": 0.21,
          "x": 1.09,
          "z": -0.01
        },
        {
          "depth": 1.3,
          "width": 0.51,
          "x": -2.56,
          "z": -1.31
        }
      ],
      "doors": [
        {
          "facing": 90,
          "id": "main",
          "width": 1.1,
          "x": 1.09,
          "z": -0.66
        }
      ],
      "footprint": {
        "depth": 4.08,
        "width": 5.12
      },
      "id": "building-house",
      "model": {
        "expectedClips": [],
        "stem": "BuildingHouse"
      },
      "walkSurfaces": [
        {
          "depth": 1.3,
          "height": 0.98,
          "width": 0.49,
          "x": 1.09,
          "z": -1.31
        },
        {
          "depth": 1.3,
          "height": 0.73,
          "width": 0.33,
          "x": 1.58,
          "z": -1.31
        },
        {
          "depth": 1.3,
          "height": 0.49,
          "width": 0.32,
          "x": 1.91,
          "z": -1.31
        },
        {
          "depth": 1.3,
          "height": 0.24,
          "width": 0.33,
          "x": 2.23,
          "z": -1.31
        }
      ]
    },
    {
      "footprint": {
        "depth": 0.64,
        "width": 2.56
      },
      "id": "stone-wall",
      "model": {
        "expectedClips": [],
        "stem": "StoneWall"
      }
    },
    {
      "colliders": [
        {
          "depth": 0.64,
          "width": 1.6,
          "x": -0.8,
          "z": -0.8
        },
        {
          "depth": 1.6,
          "width": 0.64,
          "x": -0.8,
          "z": -0.8
        }
      ],
      "footprint": {
        "depth": 1.6,
        "width": 1.6
      },
      "id": "stone-wall-corner",
      "model": {
        "expectedClips": [],
        "stem": "StoneWallCorner"
      }
    },
    {
      "footprint": {
        "depth": 0.52,
        "width": 0.86
      },
      "id": "counter",
      "model": {
        "expectedClips": [],
        "stem": "Counter"
      }
    },
    {
      "footprint": {
        "depth": 0.33,
        "width": 0.89
      },
      "id": "goods-shelf",
      "model": {
        "expectedClips": [],
        "stem": "GoodsShelf"
      }
    },
    {
      "footprint": {
        "depth": 0.9,
        "width": 0.97
      },
      "id": "crate-stack",
      "model": {
        "expectedClips": [],
        "stem": "CrateStack"
      }
    },
    {
      "footprint": {
        "depth": 0.8,
        "width": 0.84
      },
      "id": "barrel",
      "model": {
        "expectedClips": [],
        "stem": "Barrel"
      }
    },
    {
      "footprint": {
        "depth": 0.43,
        "width": 0.8
      },
      "id": "barrel-stack",
      "model": {
        "expectedClips": [],
        "stem": "BarrelStack"
      }
    },
    {
      "footprint": {
        "depth": 0.62,
        "width": 0.73
      },
      "id": "chest",
      "model": {
        "expectedClips": [],
        "stem": "Chest"
      }
    },
    {
      "footprint": {
        "depth": 0.86,
        "width": 1.52
      },
      "id": "keg",
      "model": {
        "expectedClips": [],
        "stem": "Keg"
      }
    },
    {
      "footprint": {
        "depth": 0.32,
        "width": 0.76
      },
      "id": "bench",
      "model": {
        "expectedClips": [],
        "stem": "Bench"
      }
    },
    {
      "footprint": {
        "depth": 0.83,
        "width": 0.86
      },
      "id": "round-table",
      "model": {
        "expectedClips": [],
        "stem": "RoundTable"
      }
    },
    {
      "footprint": {
        "depth": 0.86,
        "width": 1.73
      },
      "id": "long-table",
      "model": {
        "expectedClips": [],
        "stem": "LongTable"
      }
    },
    {
      "footprint": {
        "depth": 0.32,
        "width": 0.32
      },
      "id": "stool",
      "model": {
        "expectedClips": [],
        "stem": "Stool"
      }
    },
    {
      "footprint": {
        "depth": 0.86,
        "width": 1.3
      },
      "id": "bed",
      "model": {
        "expectedClips": [],
        "stem": "Bed"
      }
    },
    {
      "colliders": [],
      "footprint": {
        "depth": 0.17,
        "width": 0.22
      },
      "id": "candle",
      "light": {
        "kind": "candle",
        "x": 0.05,
        "y": 0.38,
        "z": -0.03
      },
      "model": {
        "expectedClips": [],
        "stem": "Candle"
      }
    },
    {
      "colliders": [],
      "footprint": {
        "depth": 0.86,
        "width": 1.3
      },
      "id": "rug",
      "model": {
        "expectedClips": [],
        "stem": "Rug"
      }
    },
    {
      "footprint": {
        "depth": 0.33,
        "width": 0.45
      },
      "id": "apple-crate",
      "model": {
        "expectedClips": [],
        "stem": "AppleCrate"
      }
    },
    {
      "footprint": {
        "depth": 0.54,
        "width": 0.56
      },
      "id": "fish-barrel",
      "model": {
        "expectedClips": [],
        "stem": "FishBarrel"
      }
    },
    {
      "footprint": {
        "depth": 0.19,
        "width": 0.26
      },
      "id": "flour-sacks",
      "model": {
        "expectedClips": [],
        "stem": "FlourSacks"
      }
    },
    {
      "footprint": {
        "depth": 0.71,
        "width": 0.72
      },
      "id": "cloth-bolts",
      "model": {
        "expectedClips": [],
        "stem": "ClothBolts"
      }
    },
    {
      "footprint": {
        "depth": 0.36,
        "width": 0.37
      },
      "id": "berry-basket",
      "model": {
        "expectedClips": [],
        "stem": "BerryBasket"
      }
    },
    {
      "colliders": [],
      "footprint": {
        "depth": 0.864,
        "width": 1.296
      },
      "id": "door-mat",
      "model": {
        "expectedClips": [],
        "stem": "DoorMat"
      }
    },
    {
      "colliders": [],
      "footprint": {
        "depth": 0.266,
        "width": 0.238
      },
      "id": "wall-torch",
      "light": {
        "kind": "torch",
        "x": 0,
        "y": 0.41,
        "z": 0
      },
      "model": {
        "expectedClips": [],
        "stem": "WallTorch"
      }
    },
    {
      "footprint": {
        "depth": 0.238,
        "width": 0.238
      },
      "id": "standing-torch",
      "light": {
        "kind": "torch",
        "x": 0,
        "y": 0.44,
        "z": 0
      },
      "model": {
        "expectedClips": [],
        "stem": "StandingTorch"
      }
    },
    {
      "colliders": [],
      "footprint": {
        "depth": 0.325,
        "width": 0.325
      },
      "id": "lantern",
      "light": {
        "kind": "candle",
        "x": 0,
        "y": 0.22,
        "z": 0
      },
      "model": {
        "expectedClips": [],
        "stem": "Lantern"
      }
    },
    {
      "colliders": [],
      "footprint": {
        "depth": 0.162,
        "width": 0.964
      },
      "id": "shield-banner",
      "model": {
        "expectedClips": [],
        "stem": "ShieldBanner"
      }
    },
    {
      "colliders": [],
      "footprint": {
        "depth": 0.135,
        "width": 0.648
      },
      "id": "pattern-banner",
      "model": {
        "expectedClips": [],
        "stem": "PatternBanner"
      }
    },
    {
      "colliders": [],
      "footprint": {
        "depth": 0.145,
        "width": 0.964
      },
      "id": "sword-shield-display",
      "model": {
        "expectedClips": [],
        "stem": "SwordShieldDisplay"
      }
    },
    {
      "footprint": {
        "depth": 0.471,
        "width": 0.793
      },
      "id": "archery-target",
      "model": {
        "expectedClips": [],
        "stem": "ArcheryTarget"
      }
    },
    {
      "footprint": {
        "depth": 0.691,
        "width": 0.778
      },
      "id": "armchair",
      "model": {
        "expectedClips": [],
        "stem": "Armchair"
      }
    },
    {
      "footprint": {
        "depth": 0.648,
        "width": 1.037
      },
      "id": "low-table",
      "model": {
        "expectedClips": [],
        "stem": "LowTable"
      }
    },
    {
      "colliders": [],
      "footprint": {
        "depth": 0.864,
        "width": 1.296
      },
      "id": "oval-rug",
      "model": {
        "expectedClips": [],
        "stem": "OvalRug"
      }
    },
    {
      "footprint": {
        "depth": 0.864,
        "width": 0.864
      },
      "id": "desk",
      "model": {
        "expectedClips": [],
        "stem": "Desk"
      }
    },
    {
      "colliders": [],
      "footprint": {
        "depth": 0.149,
        "width": 0.406
      },
      "id": "open-book",
      "model": {
        "expectedClips": [],
        "stem": "OpenBook"
      }
    },
    {
      "colliders": [],
      "footprint": {
        "depth": 0.159,
        "width": 0.159
      },
      "id": "bottles",
      "model": {
        "expectedClips": [],
        "stem": "Bottles"
      }
    },
    {
      "footprint": {
        "depth": 0.216,
        "width": 0.864
      },
      "id": "jar-shelf",
      "model": {
        "expectedClips": [],
        "stem": "JarShelf"
      }
    },
    {
      "colliders": [],
      "footprint": {
        "depth": 0.216,
        "width": 0.864
      },
      "id": "wall-shelf",
      "model": {
        "expectedClips": [],
        "stem": "WallShelf"
      }
    },
    {
      "colliders": [],
      "footprint": {
        "depth": 0.159,
        "width": 0.203
      },
      "id": "mug",
      "model": {
        "expectedClips": [],
        "stem": "Mug"
      }
    },
    {
      "colliders": [
        {
          "depth": 0.375,
          "width": 0.378,
          "x": -0.188,
          "z": -0.338
        }
      ],
      "footprint": {
        "depth": 1.374,
        "width": 1.405
      },
      "id": "tree-1-a",
      "model": {
        "expectedClips": [],
        "stem": "Tree1A"
      }
    },
    {
      "colliders": [
        {
          "depth": 0.396,
          "width": 0.388,
          "x": -0.284,
          "z": -0.197
        }
      ],
      "footprint": {
        "depth": 1.489,
        "width": 1.731
      },
      "id": "tree-1-b",
      "model": {
        "expectedClips": [],
        "stem": "Tree1B"
      }
    },
    {
      "colliders": [
        {
          "depth": 0.495,
          "width": 0.499,
          "x": -0.522,
          "z": -0.248
        }
      ],
      "footprint": {
        "depth": 2.486,
        "width": 2.891
      },
      "id": "tree-1-c",
      "model": {
        "expectedClips": [],
        "stem": "Tree1C"
      }
    },
    {
      "colliders": [
        {
          "depth": 0.2,
          "width": 0.2,
          "x": -0.203,
          "z": -0.242
        }
      ],
      "footprint": {
        "depth": 0.907,
        "width": 1.599
      },
      "id": "tree-2-b",
      "model": {
        "expectedClips": [],
        "stem": "Tree2B"
      }
    },
    {
      "colliders": [
        {
          "depth": 0.264,
          "width": 0.261,
          "x": -0.045,
          "z": -0.05
        }
      ],
      "footprint": {
        "depth": 1.469,
        "width": 1.987
      },
      "id": "tree-2-c",
      "model": {
        "expectedClips": [],
        "stem": "Tree2C"
      }
    },
    {
      "colliders": [
        {
          "depth": 0.378,
          "width": 0.375,
          "x": -0.187,
          "z": -0.19
        }
      ],
      "footprint": {
        "depth": 1.336,
        "width": 1.336
      },
      "id": "tree-3-a",
      "model": {
        "expectedClips": [],
        "stem": "Tree3A"
      }
    },
    {
      "colliders": [
        {
          "depth": 0.396,
          "width": 0.388,
          "x": -0.184,
          "z": -0.198
        }
      ],
      "footprint": {
        "depth": 1.784,
        "width": 1.784
      },
      "id": "tree-3-b",
      "model": {
        "expectedClips": [],
        "stem": "Tree3B"
      }
    },
    {
      "colliders": [
        {
          "depth": 0.211,
          "width": 0.216,
          "x": -0.108,
          "z": -0.148
        }
      ],
      "footprint": {
        "depth": 0.916,
        "width": 1.026
      },
      "id": "tree-5-a",
      "model": {
        "expectedClips": [],
        "stem": "Tree5A"
      }
    },
    {
      "colliders": [
        {
          "depth": 0.187,
          "width": 0.185,
          "x": 0.02,
          "z": -0.145
        }
      ],
      "footprint": {
        "depth": 0.734,
        "width": 0.904
      },
      "id": "tree-6-a",
      "model": {
        "expectedClips": [],
        "stem": "Tree6A"
      }
    },
    {
      "colliders": [
        {
          "depth": 0.212,
          "width": 0.211,
          "x": -0.181,
          "z": -0.112
        }
      ],
      "footprint": {
        "depth": 1.25,
        "width": 1.358
      },
      "id": "tree-7-a",
      "model": {
        "expectedClips": [],
        "stem": "Tree7A"
      }
    },
    {
      "colliders": [
        {
          "depth": 0.378,
          "width": 0.375,
          "x": -0.208,
          "z": -0.154
        }
      ],
      "footprint": {
        "depth": 0.447,
        "width": 0.488
      },
      "id": "tree-bare-1-a",
      "model": {
        "expectedClips": [],
        "stem": "TreeBare1A"
      }
    },
    {
      "colliders": [
        {
          "depth": 0.396,
          "width": 0.388,
          "x": -0.424,
          "z": -0.082
        }
      ],
      "footprint": {
        "depth": 0.627,
        "width": 0.849
      },
      "id": "tree-bare-1-b",
      "model": {
        "expectedClips": [],
        "stem": "TreeBare1B"
      }
    },
    {
      "colliders": [
        {
          "depth": 0.351,
          "width": 0.351,
          "x": -0.183,
          "z": -0.176
        }
      ],
      "footprint": {
        "depth": 1.795,
        "width": 2.056
      },
      "id": "autumn-pine-orange-large",
      "model": {
        "expectedClips": [],
        "stem": "AutumnPineOrangeLarge"
      }
    },
    {
      "colliders": [
        {
          "depth": 0.304,
          "width": 0.304,
          "x": -0.147,
          "z": -0.241
        }
      ],
      "footprint": {
        "depth": 1.348,
        "width": 1.439
      },
      "id": "autumn-pine-orange-medium",
      "model": {
        "expectedClips": [],
        "stem": "AutumnPineOrangeMedium"
      }
    },
    {
      "colliders": [
        {
          "depth": 0.351,
          "width": 0.351,
          "x": -0.183,
          "z": -0.176
        }
      ],
      "footprint": {
        "depth": 1.795,
        "width": 2.056
      },
      "id": "autumn-pine-yellow-large",
      "model": {
        "expectedClips": [],
        "stem": "AutumnPineYellowLarge"
      }
    },
    {
      "colliders": [
        {
          "depth": 0.304,
          "width": 0.304,
          "x": -0.147,
          "z": -0.241
        }
      ],
      "footprint": {
        "depth": 1.348,
        "width": 1.439
      },
      "id": "autumn-pine-yellow-medium",
      "model": {
        "expectedClips": [],
        "stem": "AutumnPineYellowMedium"
      }
    },
    {
      "footprint": {
        "depth": 0.371,
        "width": 0.371
      },
      "id": "bush-2-b",
      "model": {
        "expectedClips": [],
        "stem": "Bush2B"
      }
    },
    {
      "footprint": {
        "depth": 0.44,
        "width": 0.679
      },
      "id": "bush-2-d",
      "model": {
        "expectedClips": [],
        "stem": "Bush2D"
      }
    },
    {
      "footprint": {
        "depth": 0.446,
        "width": 0.446
      },
      "id": "bush-3-a",
      "model": {
        "expectedClips": [],
        "stem": "Bush3A"
      }
    },
    {
      "footprint": {
        "depth": 0.249,
        "width": 0.249
      },
      "id": "bush-4-a",
      "model": {
        "expectedClips": [],
        "stem": "Bush4A"
      }
    },
    {
      "footprint": {
        "depth": 0.25,
        "width": 0.263
      },
      "id": "rock-1-a",
      "model": {
        "expectedClips": [],
        "stem": "Rock1A"
      }
    },
    {
      "footprint": {
        "depth": 0.401,
        "width": 0.5
      },
      "id": "rock-1-d",
      "model": {
        "expectedClips": [],
        "stem": "Rock1D"
      }
    },
    {
      "footprint": {
        "depth": 0.349,
        "width": 0.413
      },
      "id": "rock-3-a",
      "model": {
        "expectedClips": [],
        "stem": "Rock3A"
      }
    },
    {
      "footprint": {
        "depth": 0.432,
        "width": 1.28
      },
      "id": "stone-room-wall",
      "model": {
        "expectedClips": [],
        "stem": "StoneRoomWall"
      }
    },
    {
      "footprint": {
        "depth": 0.432,
        "width": 1.28
      },
      "id": "stone-room-window-wall",
      "model": {
        "expectedClips": [],
        "stem": "StoneRoomWindowWall"
      }
    },
    {
      "footprint": {
        "depth": 0.432,
        "width": 1.28
      },
      "id": "stone-room-wall-low",
      "model": {
        "expectedClips": [],
        "stem": "StoneRoomWallLow"
      }
    },
    {
      "footprint": {
        "depth": 0.648,
        "width": 0.648
      },
      "id": "stone-room-pillar",
      "model": {
        "expectedClips": [],
        "stem": "StoneRoomPillar"
      }
    },
    {
      "footprint": {
        "depth": 0.648,
        "width": 0.648
      },
      "id": "stone-room-pillar-low",
      "model": {
        "expectedClips": [],
        "stem": "StoneRoomPillarLow"
      }
    },
    {
      "footprint": {
        "depth": 0.2,
        "width": 1.28
      },
      "id": "timber-room-wall",
      "model": {
        "expectedClips": [],
        "stem": "TimberRoomWall"
      }
    },
    {
      "footprint": {
        "depth": 0.24,
        "width": 1.28
      },
      "id": "timber-room-window-wall",
      "model": {
        "expectedClips": [],
        "stem": "TimberRoomWindowWall"
      }
    },
    {
      "footprint": {
        "depth": 0.24,
        "width": 1.28
      },
      "id": "timber-room-wall-low",
      "model": {
        "expectedClips": [],
        "stem": "TimberRoomWallLow"
      }
    },
    {
      "footprint": {
        "depth": 0.28,
        "width": 0.28
      },
      "id": "timber-room-post",
      "model": {
        "expectedClips": [],
        "stem": "TimberRoomPost"
      }
    },
    {
      "footprint": {
        "depth": 0.28,
        "width": 0.28
      },
      "id": "timber-room-post-low",
      "model": {
        "expectedClips": [],
        "stem": "TimberRoomPostLow"
      }
    },
    {
      "colliders": [],
      "doors": [
        {
          "facing": 180,
          "id": "main",
          "width": 2.0,
          "x": 0,
          "z": -0.12
        }
      ],
      "footprint": {
        "depth": 0.24,
        "width": 2.28
      },
      "id": "timber-room-threshold",
      "model": {
        "expectedClips": [],
        "stem": "TimberRoomThreshold"
      }
    },
    {
      "colliders": [],
      "doors": [
        {
          "facing": 180,
          "id": "main",
          "width": 1.6,
          "x": 0,
          "z": -0.216
        }
      ],
      "footprint": {
        "depth": 0.672,
        "width": 1.912
      },
      "id": "stone-room-threshold",
      "model": {
        "expectedClips": [],
        "stem": "StoneRoomThreshold"
      }
    },
    {
      "colliders": [],
      "footprint": {
        "depth": 1.28,
        "width": 1.28
      },
      "id": "floor-boards",
      "model": {
        "expectedClips": [],
        "stem": "FloorBoards"
      }
    },
    {
      "footprint": {
        "depth": 0.87,
        "width": 1.8
      },
      "id": "stone-hearth",
      "light": {
        "kind": "hearth",
        "x": 0,
        "y": 0.25,
        "z": -0.055
      },
      "model": {
        "expectedClips": [],
        "stem": "StoneHearth"
      }
    },
    {
      "colliders": [],
      "footprint": {
        "depth": 0.066,
        "width": 0.147
      },
      "id": "grass-1-a",
      "model": {
        "expectedClips": [],
        "stem": "Grass1A"
      }
    },
    {
      "colliders": [],
      "footprint": {
        "depth": 0.218,
        "width": 0.24
      },
      "id": "grass-1-b",
      "model": {
        "expectedClips": [],
        "stem": "Grass1B"
      }
    },
    {
      "colliders": [],
      "footprint": {
        "depth": 0.067,
        "width": 0.11
      },
      "id": "grass-2-a",
      "model": {
        "expectedClips": [],
        "stem": "Grass2A"
      }
    },
    {
      "colliders": [],
      "footprint": {
        "depth": 0.172,
        "width": 0.174
      },
      "id": "grass-2-b",
      "model": {
        "expectedClips": [],
        "stem": "Grass2B"
      }
    },
    {
      "colliders": [],
      "footprint": {
        "depth": 0.082,
        "width": 0.082
      },
      "id": "pebble",
      "model": {
        "expectedClips": [],
        "stem": "Pebble"
      }
    }
  ],
  "playerModel": "dreamer"
}
